export function setupDialog() {
    const closeButtons = document.querySelectorAll(".dialog-close-button");

    for (const button of closeButtons) {

        const dialog = button.closest('dialog');

        if (!dialog) continue;

        button.addEventListener('click', () => {
            dialog.close();
        });
    }
}